"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Modal_1 = tslib_1.__importDefault(require("../Modal"));
var CloseButton_1 = tslib_1.__importDefault(require("../CloseButton"));
var styled_1 = require("./styled");
var ImageModal = function (_a) {
    var src = _a.src, onClose = _a.onClose, isOpen = _a.isOpen, children = _a.children;
    return (react_1.default.createElement(Modal_1.default, { onClose: onClose, isOpen: isOpen },
        react_1.default.createElement(styled_1.Thumbnail, { src: src },
            react_1.default.createElement(styled_1.CloseContainer, null,
                react_1.default.createElement(CloseButton_1.default, { onClick: onClose }))),
        children));
};
exports.default = ImageModal;
//# sourceMappingURL=index.js.map